import {useLocation} from 'react-router';

import {ONBOARDING_FLOW_PATH} from '../../../routes/onboarding/onboardingPaths';

export function useIsSignupRoute() {
  const location = useLocation();
  return location.pathname === ONBOARDING_FLOW_PATH;
}
